import { Vue, Prop, Inject, Component, InjectReactive } from "vue-property-decorator";
import Validator from "../../components/Validator/validator.vue";
import { loadLoginCurrent, PltUser, current, getCookie } from "@szgc/plt-core-v2";
import request from "../../api/request";

let currentLocal!: PltUser;
let _sysconfig!: any;
let pending = false;
let pendingFinishFn: () => void;
let pendingPromise: Promise<void>;

async function loadBaseInfo() {
  try {
    if (currentLocal && _sysconfig) {
      return;
    }
    pendingPromise = new Promise<void>((resolve) => {
      pending = true;
      pendingFinishFn = resolve;
    });
    if (!currentLocal) {
      const { data } = await loadLoginCurrent();

      currentLocal = data;
    }

    if (!_sysconfig) {
      const prefix = getCookie("plt-api-route") || "";

      const result = await request({
        url: `${prefix}/secure/current`,
        method: "get"
      });
      if (result.success) {
        _sysconfig = result.data;
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    pending = false;
    if (pendingFinishFn) {
      pendingFinishFn();
    }
  }
}

loadBaseInfo();

@Component({
  name: "WidgetBase",
  components: { Validator }
})
export default class WidgetBase<T extends App.WebForm.Widget = App.WebForm.Widget> extends Vue {
  constructor(...args: any[]) {
    super(...args);
    // 处理重复多次请求
    if (pending) {
      pendingPromise.then(() => {
        loadBaseInfo();
      });
    } else {
      loadBaseInfo();
    }
  }

  @Prop({
    required: true,
    type: Object
  })
  widget!: T;

  @InjectReactive("htmlOptions")
  protected htmlOptions!: { isHtml: boolean; options: App.WebForm.Config };

  @InjectReactive("rules")
  protected rules!: any;

  protected get isHtml() {
    return this.htmlOptions.isHtml;
  }

  get current() {
    return currentLocal;
  }
  /**
   * 获取当前用户信息, 在第一次打开时可能不能及时获取到用户信息，所以需要异步获取
   * @returns 
   */
  getCurrentSync (): Promise<PltUser> {
    return new Promise((resolve) => {
      loadBaseInfo().then(() => {
        resolve(currentLocal);
      });
    });
  }

  get sysconfig() {
    return _sysconfig;
  }

  @Prop({
    type: Object
  })
  model!: any;

  @Inject()
  originDataFn!: any;

  @Inject()
  status!: "mine" | "todo" | "done" | "wait" | "sent" | "fine" | "term" | "cc";

  originData = this.originDataFn();

  get defaultValue(): any {
    if (!this.widget.defaultValue) return "";
    const group = this.widget.defaultValue.group;
    const field = this.widget.defaultValue.field;
    if (group === "user") {
      return { field, value: (current as any)[field] };
    } else if (group === "script") {
      const date = new Date(this.originData?.results?.createTime?.object || new Date());
      if (field === "systemTime") {
        return date.valueOf();
      } else if (field === "year") {
        return date.getFullYear();
      } else if (field === "month") {
        return date.getMonth() + 1;
      } else if (field === "day") {
        return date.getDate();
      } else {
        return "";
      }
    } else if (group === "custom") {
      return this.widget.defaultValue.value || "";
    }
    return "";
  }

  get name() {
    return this.widget.isSubWidget ? "" : this.widget.name;
  }

  get labelWidth() {
    return this.widget.isSubWidget ? "0" : "";
  }

  get value() {
    const { widget } = this;
    let val = this.widget.isSubWidget
      ? this.widget.value
      : this.model[widget.property.propertyName];

    if (widget.property.propertyType === "date") {
      val = val ? new Date(Number(val)).getTime() : "";
      if (this.widget.isSubWidget) {
        this.widget.value = val;
      } else {
        this.model[widget.property.propertyName] = val;
      }
    }

    if (widget.property.propertyType === "dateScope") {
      val = this.initDateScopeValue(val);
    }

    // if (widget.property.propertyType === "dictionaries" && val) {
    //   const [prefix, v] = val.split(":");
    //   val = v.split(",").map((i: string) => `${prefix}:${i}`).join();
    // }

    return val === null ? "" : val;
  }

  set value(val: any) {
    const { property } = this.widget;

    if (property.propertyType === "dateScope") {
      if (Object.prototype.toString.call(val) === "[object Array]") {
        const [start, end] = val;

        val = `${this.widget.widgetFormat.replace(/YYYY|DD/g, (word: string) =>
          word.toLowerCase()
        )};${start};${end}`;
      } else val = "";
    }

    // if (property.propertyType === "dictionaries") {
    //   val = val
    //     .map((i: string, idx: number) => (idx === 0 ? i : i.split(":")[1]))
    //     .join(",");
    // }

    this.widget.isSubWidget
      ? this.$set(this.widget, "value", val === "" ? null : val)
      : this.$set(this.model, property.propertyName, val === "" ? null : val);
  }

  mounted() {
    this.$nextTick(() => {
      (this as any).handleEvent && (this as any).handleEvent(this.value, true);
    });
  }

  get prop() {
    return this.widget.isSubWidget ? "" : this.widget.property.propertyName;
  }

  initDateScopeValue(val: string): Date[] {
    const [start, end] = val.split(";").splice(1);

    if (start && end) {
      const reg = /(\d{4})(.*)(\d{2})(.*)(\d{2})(.*)/;
      const startDate = new Date(start.replace(reg, "$1-$3-$5"));
      const endDate = new Date(end.replace(reg, "$1-$3-$5"));

      return [new Date(startDate), new Date(endDate)];
    }

    return [];
  }
}

